import axios from 'axios'

export function storeEvent ({ commit }, event) {
  return new Promise((resolve, reject) => {
    commit('STORE_EVENT')
    axios.post('/api/messaging/v1/events', event)
      .then(response => {
        commit('EVENT_STORED', response.data)
        resolve()
      }).catch(err => {
        const msg = !err ? 'Unbekannter Fehler' : err.response.status + ' - ' + err.response.statusText + ': ' + err.response.data
        commit('EVENT_ERROR', msg)
        reject(err)
      })
  })
}

export function getEvent ({ commit }, { start = 0, limit = 10, filter = 'stufe:*' }) {
  return new Promise((resolve, reject) => {
    commit('GET_EVENTS')
    axios.get(`/api/messaging/v1/events?filter=${filter}&start=${start}&limit=${limit}`)
      .then(response => {
        commit('RECEIVE_EVENTS', { events: response.data, start })
        resolve()
      }).catch(err => {
        const msg = !err ? 'Unbekannter Fehler' : err.response.status + ' - ' + err.response.statusText + ': ' + err.response.data
        commit('EVENTS_ERROR', msg)
      })
  })
}
